import React from 'react';
import { FormSection, FieldArray , getFormValues} from 'redux-form';
import { connect } from "react-redux"
import { CLIENT_FORM } from 'src/constants/FormNames';
import classNames from 'classnames';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import Button from 'jbc-front/components/Button';
import { Section } from 'src/jbc-front/components/Form';
import { CLIENT_SETTINGS, LIST_COMPANY_URL } from 'src/constants/EndpointUrls';
import ClientSection from '../containers/ClientSection';
import BranchSection from './BranchSection';
// import ImageSection from '../containers/ImageSection';
import CompanyImageSection from '../containers/CompanyImageSection';
import styles from './NewCompany.scss';
// import FormErrors from 'src/components/FormErrors';
import { ErrorsSection } from 'src/components';
import { useTranslation } from 'react-i18next';

const NewCompany = props => {
  const { t } = useTranslation();
  const { handleSubmit, submit, errors, pristine, submitting, client, isNewForm } = props;


  return (
    <div className="l-wrap-xl l-contents-wrap">
      <div className="u-mb20">
        <BreadCrumb>
          <BreadCrumb.Item label={t('features.Clients.components.NewCompany.setting')} path={CLIENT_SETTINGS} />
          <BreadCrumb.Item label={t('features.Clients.components.NewCompany.register_office_information')} />
        </BreadCrumb>
      </div>
      <div className="l-wrap-xl">
        <div className="l-title-wrap">
          <h1 className="m-title-main">{t('features.Clients.components.NewCompany.register_office_information')}</h1>
        </div>
      </div>
      {/* form */}
      <div className="l-flex">
        <div className="l-flex6-main">

          <form className={styles.form} onSubmit={handleSubmit}>
            <ErrorsSection errors={errors} />
            
            <React.Fragment>
              <Section title={t('features.Clients.components.NewCompany.office_information')}>
                <FormSection name="client">
                  <ClientSection isNewForm={isNewForm} />
                </FormSection>
              </Section>

              <Section title={t('features.Clients.components.NewCompany.branch_information')}>
                <div>
                  <FieldArray name="clientBranch" component={BranchSection} isNewForm={isNewForm} />
                </div>
              </Section>

              <Section title={t('features.Clients.components.NewCompany.image_information')}>
                  <FormSection name="client">
                      <CompanyImageSection isNewForm={isNewForm} />
                  </FormSection>
              </Section>
            </React.Fragment>

            <div className="u-ta-c u-mt20">
              <Button as="a" href={LIST_COMPANY_URL} className="u-mr20">
                {t('features.Clients.components.NewCompany.cancel')}
              </Button>
              <Button disabled={pristine || submitting} onClick={submit} primary>
                {t('features.Clients.components.NewCompany.save')}
              </Button>
            </div>
          </form>

        </div>
      </div>
    </div>
  );
};

export default NewCompany;